import WidgetNotice from './widgetNotice.vue';
import WidgetValue from './widgetValue.vue';
import WidgetChartBar from './widgetChartBar.vue';
// import WidgetHistory from './widgetHistory.vue';
import WidgetChartMultiBar from './widgetChartMultiBar.vue';
// import WidgetChartGauge from './widgetChartGauge.vue';
import WidgetChartLine from './widgetChartLine.vue';
import WidgetList from './widgetList.vue';
import WidgetDesc from './widgetDesc.vue';
import WidgetCustom from './widgetCustom.vue';
import WidgetChartPie from './widgetChartPie.vue';
import widgetFreeTrial from './widgetFreeTrial.vue';

export default {
  install(Vue) {
    Vue.component(WidgetNotice.name, WidgetNotice);
    Vue.component(WidgetValue.name, WidgetValue);
    Vue.component(WidgetChartBar.name, WidgetChartBar);
    // Vue.component(WidgetHistory.name, WidgetHistory);
    Vue.component(WidgetChartMultiBar.name, WidgetChartMultiBar);
    // Vue.component(WidgetChartGauge.name, WidgetChartGauge);
    Vue.component(WidgetChartLine.name, WidgetChartLine);
    Vue.component(WidgetList.name, WidgetList);
    Vue.component(WidgetDesc.name, WidgetDesc);
    Vue.component(WidgetCustom.name, WidgetCustom);
    Vue.component(WidgetChartPie.name, WidgetChartPie);
    Vue.component(widgetFreeTrial.name, widgetFreeTrial);
  },
};
